import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { VendorsModule } from "../features/vendors/vendors.module";
import { VenuesModule } from "../features/venues/venues.module";
import { AuthFeaturePromoComponent } from "./auth/auth-feature-promo/auth-feature-promo.component";
import { AuthPageWrapperComponent } from "./auth/auth-page-wrapper/auth-page-wrapper.component";
import { FloatingSignupButtonComponent } from "./auth/floating-signup-button/floating-signup-button.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { LoginComponent } from "./auth/login/login.component";
import { LogoutComponent } from "./auth/logout/logout.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { SamlCaptureComponent } from "./auth/saml-capture/saml-capture.component";
import { SignupAccountTypeComponent } from "./auth/signup/signup-account-type/signup-account-type.component";
import { SignupClientWarningComponent } from "./auth/signup/signup-client-warning/signup-client-warning.component";
import { SignupUserInfoComponent } from "./auth/signup/signup-user-info/signup-user-info.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { HomepageFeaturedPartnersComponent } from "./homepage-featured-partners/homepage-featured-partners.component";
import { HomepageHowItWorksWidgetComponent } from "./homepage-how-it-works-widget/homepage-how-it-works-widget.component";
import { HomepageVenueJoinComponent } from "./homepage-venue-join/homepage-venue-join.component";
import { HomepageTestimonialComponent, TestimonialDisplayComponent } from "./homepage/components";
import { HomepageComponent } from "./homepage/homepage.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { PublicHeaderComponent } from "./public-header/public-header.component";
import { PublicRoutingModule } from "./public-routing.module";
import { PlanChooserItemComponent } from "./splash/plan-chooser/plan-chooser-item/plan-chooser-item.component";
import { PlanChooserComponent } from "./splash/plan-chooser/plan-chooser.component";
import { SplashHeaderComponent } from "./splash/splash-header/splash-header.component";
import { SplashComponent } from "./splash/splash.component";

@NgModule({
  declarations: [
    SplashComponent,
    PageNotFoundComponent,
    SplashHeaderComponent,
    PlanChooserComponent,
    PlanChooserItemComponent,
    LoginComponent,
    PublicHeaderComponent,
    SignupComponent,
    SignupUserInfoComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    LogoutComponent,
    HomepageComponent,
    HomepageFeaturedPartnersComponent,
    HomepageTestimonialComponent,
    TestimonialDisplayComponent,
    SignupAccountTypeComponent,
    HomepageHowItWorksWidgetComponent,
    FloatingSignupButtonComponent,
    HomepageVenueJoinComponent,
    MaintenanceComponent,
    SignupClientWarningComponent,
    AuthPageWrapperComponent,
    AuthFeaturePromoComponent,
    SamlCaptureComponent,
  ],
  imports: [SharedModule, VenuesModule, VendorsModule, PublicRoutingModule],
  exports: [PublicHeaderComponent, FloatingSignupButtonComponent],
})
export class PublicModule {}
